import { Link } from 'react-router-dom';
import './Store.css';

const Store = () => {
    return (
        <section className="section-header account-page store-page">
            <div className="view-container">
                <div className="store-placeholder">
                    <h1>Store</h1>
                    <p>This feature is not currently available. We're working hard to bring you a marketplace for premium products and services. Stay tuned for the launch.</p>
                    <Link to={'/account'} className="store-btn">Go to Dashboard →</Link>
                </div>
            </div>
        </section>
    )
}

export default Store
